import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "@emotion/styled";
import {getColor} from "@/styles/ThemeConfig";
import SliderArrowRightWhiteIcon from '/public/images/slider_arrow_right_white.svg'
import SliderArrowRightGreenIcon from '/public/images/slider_arrow_right_green.svg'
import {breakpoints} from "@/styles/sizes";

import ArrowRightGold2 from '/public/images/arrow_right_gold_2.svg';
import ArrowLeftGold2 from '/public/images/arrow_left_gold_2.svg';
import Image from "next/image";

const ButtonControls = styled.div`
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    line-height: 1;

    .image {
        width: 40px;
        height: 40px;
        background-image: url(${props => props.$arrowImage});
        background-size: 50% 50%;
        background-repeat: no-repeat;
        background-position: center;
        transition: 0.3s ease; /* Optional for smooth transition */
        
        ${props => props.$arrowImageRotated ? `transform: scaleX(-1);` : null}
    }
    
`;

const ButtonControlsGreen = styled.div`
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid ${getColor('green')};
    background-color: ${getColor('lightGreen')};
    line-height: 1;

    .image {
        display: block;
        width: 40px;
        height: 40px;
        background-image: url(${props => props.$arrowImage});
        background-size: 50% 50%;
        background-repeat: no-repeat;
        background-position: center;
        transition: 0.3s ease; /* Optional for smooth transition */

        ${props => props.$arrowImageRotated ? `transform: scaleX(-1);` : null}
    }

    :hover{
        background-color: ${getColor('green')};
        .image{
            background-image: url(${props => props.$arrowImageHover});
        }
    }
`;

const SidebarTitle = styled.div`
    text-align: center;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    writing-mode: vertical-lr;
    text-orientation: mixed;
    font: 52px Josefin Sans;
    font-weight: 700;
    letter-spacing: 3px;
    -webkit-text-fill-color: #fff;
    -webkit-text-stroke-color: #859f95;
    -webkit-text-stroke-width: 1px;
    text-transform: uppercase;
`;

const SliderWrapper = styled.div`
    width: 100%;
`;

const TitleWrapper = styled.div`
    padding-bottom: 5px;
    text-transform: uppercase;
    @media only screen and (${breakpoints.mobile}) {
    }
`;


const TitleContentWrapper = styled.div`
    display:flex;
    align-items:flex-end;
    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        align-items: flex-start;
        padding:0 25px;
        .h4{
            font-size: 20px!important;
            line-height: 25px!important;
        }
    }
`;

export default function HomepageSlider({
                                           items,
                                           title,
                                            subtitle,
                                            sidebarTitle,
                                           renderItem,
                                           headerVariant = "default",
    ...rest
                                       }){

    let slider;


    const settings = {
        className:'left',
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll:1,
        swipeToSlide: true,
        variableWidth: true,
        rows: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll:1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll:1,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    // centerMode:true,
                    slidesToShow: 1,
                    slidesToScroll:1,
                }
            }
        ]
    };
    return((items && items?.length > 0) &&
        <div style={{
            width: '100%',
            overflow: "hidden",
        }}>

            <div className={'container'} style={{display: "flex", justifyContent: "space-between", alignItems: 'center'}}>

                <TitleContentWrapper

                >
                    <h2
                        style={{
                            fontSize: '80px',
                            lineHeight: '90px',
                            color: headerVariant === 'white' ? 'white' : getColor('gold'),
                            fontFamily: 'Birthstone',
                            marginRight: '15px',
                            background: headerVariant === 'white'
                                ? 'linear-gradient(to top, transparent 15%, rgba(255,255,255,0.3) 15%, rgba(255,255,255,0.3) 45%, transparent 45%)'
                                : 'linear-gradient(to top, transparent 15%, rgba(189, 155, 97,0.3) 15%, rgba(189, 155, 97,0.3) 45%, transparent 45%)',
                            display: 'inline-block',
                            padding: '0 5px'
                        }}
                    >{sidebarTitle}</h2>

                    <TitleWrapper>
                        {title && <h2 className={'h4'} style={{fontSize:'25px',lineHeight:'30px', color: headerVariant === 'white' ? 'white' : 'black',}}>{title}</h2>}
                        {subtitle && <h2 className={'h4'} style={{fontSize:'25px',lineHeight:'30px', fontWeight: 'bold', color: headerVariant === 'white' ? 'white' : 'black'}}>{subtitle}</h2>}
                    </TitleWrapper>
                </TitleContentWrapper>


                <div className={'desktop_only'} style={{marginRight:'10px'}}>
                    <div style={{display: "flex"}}>
                        <ButtonControls
                            onClick={() => slider.slickPrev()}
                        >
                            <Image src={ArrowLeftGold2} alt={'ArrowLeft'}/>
                        </ButtonControls>

                        <ButtonControls
                            onClick={() => slider.slickNext()}
                        >
                            <Image src={ArrowRightGold2} alt={'ArrowRight'}/>
                        </ButtonControls>
                    </div>
                </div>
            </div>

            <div style={{
                display: 'flex',
                overflow: 'visible',
                paddingLeft: 'calc(50vw - 750px)',
                alignItems: 'stretch',
            }}>
                <SliderWrapper>
                    <div style={{
                        overflow: 'visible',
                    }}>
                        <Slider ref={c => (slider = c)} {...settings} style={{overflow: 'visible', }}>
                            {items.map(function (item, index) {
                                return <div key={index} style={{margin: '20px'}}>{renderItem(item)}</div>;
                            })}
                        </Slider>
                    </div>
                </SliderWrapper>
            </div>



        </div>
    );
}



